// ✅ Single API URL config
const API_BASE_URL = "http://payments.intotheam.com/private-shopify-app/wishlist/index.php";

class WishlistButton extends HTMLElement {
  constructor() {
    super();
    this.productId = this.getAttribute("product-id");
    this.customerId = this.getAttribute("customer-id"); // null if not logged in
    this.email = this.getAttribute("customer-email");
    this.page = window.location.href;
    this.product = {
      handle : this.getAttribute('product-handle'),
      name : this.getAttribute('product-name'),
      variant : this.getAttribute('variant-id') || '',
    }
    this.inWishlist = this.getAttribute('data-status') == 'true' ? true : false;

    // Create button
    this.button = this.querySelector("button");
    
    // this.button.textContent = this.inWishlist == true ? "♥ Added" : "♡ Add";
    if(this.page.indexOf('pages/wishlist') > 0){
      // this.button.textContent = "X";
    }else{
      // this.button.textContent = '';
      // this.button.textContent = this.inWishlist == true ? "♥ Added" : "♡ Add";
      // this.button.classList.add(this.inWishlist == true ? "wl-added" : "");
    }

    if(this.querySelector('button') != null){
      this.button.addEventListener("click", () => this.handleClick());
      // this.appendChild(this.button);
    }
  }

  /**
   * Handle button click
   */
  handleClick() {
    if (!this.customerId) {
      this.showLoginModal();
      return;
    }
    this.toggleWishlist();
  }

  /**
   * Generic API request helper
   */
  async request(method) {
    const metadata = {
      product: this.product,
      store: {
        store_shopify_url: window.Shopify.shop,
        routes: window.Shopify.routes,
        country: window.Shopify.country
      }
    };
    try {
      const response = await fetch(API_BASE_URL, {
        method,
        mode: 'cors',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          product_id: this.productId,
          customer_id: this.customerId,
          customer_email: this.email,
          metadata: metadata
        }),
      });
      return response.json();
    } catch (error) {
      console.error(`Wishlist ${method} error:`, error);
      return null;
    }
  }

  /**
   * Toggle wishlist state
   */
  async toggleWishlist() {
    document.querySelector('body').classList.add('loading');
    this.button.disabled = true;
    const method = this.inWishlist ? "DELETE" : "POST";
    const result = await this.request(method);

    if (result.status == 'success') {
      if(this.page.indexOf('pages/wishlist') > 0){
        // window.location.reload();
        this.closest('.product-block').remove();
        if(document.querySelectorAll('.wishlist-section .product-block').length == 0){
          window.location.reload();
        }
      }else{
        this.inWishlist = !this.inWishlist;
        this.updateButton();
      }
    }
  }

  /**
   * Update button UI
   */
  updateButton() {
    if(this.inWishlist){
      this.button.classList.add('wl-added');
    }else{
      this.button.classList.remove('wl-added');
    }
    this.button.disabled = false;
    document.querySelector('body').classList.remove('loading');
  }

  /**
   * Show login/signup modal
   */
  showLoginModal() {
    // Check if modal already exists
    let modal = document.querySelector("#wishlist-login-modal");
    if (!modal) {
      modal = document.createElement("div");
      modal.id = "wishlist-login-modal";
      modal.innerHTML = `
        <div style="
          position: fixed; top: 0; left: 0; width: 100%; height: 100%;
          background: rgba(0,0,0,0.6); display: flex; align-items: center; justify-content: center;
          z-index: 9999;">
          <div style="background: #fff; padding: 20px; border-radius: 8px; width: 300px; text-align: center;">
            <h3>Please Log In</h3>
            <p>You need an account to save items to your wishlist.</p>
            <button id="wishlist-login-btn" style="margin: 5px; padding: 8px 12px;">Login</button>
            <button id="wishlist-signup-btn" style="margin: 5px; padding: 8px 12px;">Sign Up</button>
            <button id="wishlist-close-btn" style="margin-top: 10px; padding: 6px 10px;">Close</button>
          </div>
        </div>
      `;
      document.body.appendChild(modal);

      // Button actions
      document.querySelector("#wishlist-login-btn").onclick = () => {
        window.location.href = `/account/login?return_to=${window.location.pathname}`; // change to your login page
      };
      document.querySelector("#wishlist-signup-btn").onclick = () => {
        window.location.href = "/account/register"; // change to your signup page
      };
      document.querySelector("#wishlist-close-btn").onclick = () => {
        modal.remove();
      };
    }
  }
}

// ✅ Register custom element
customElements.define("wishlist-button", WishlistButton);

document.addEventListener('DOMContentLoaded', function() {
  const params = new URLSearchParams(window.location.search);
  const returnTo = params.get('return_to');

  if (returnTo) {
    const form = document.querySelector('form[action="/account/login"]');
    if (form) {
      form.action = `/account/login?return_to=${encodeURIComponent(returnTo)}`;
    }
  }
});